import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ApiService, requiredFileType, markAllAsDirty, toFormData, requiredFileSize } from 'src/app/_services/api.service';

@Component({
    selector: 'app-businessForm',
    templateUrl: './businessForm.component.html',
    styleUrls: ['./businessForm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessFormComponent {

  progress = 0;
  contactForm: any;
  success = false;

  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.contactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      assessment: [''],
      index: [''],
        number: ['', Validators.required],
        direction: '',
        street: ['', Validators.required],
        type: '',
        unit: '',
        city: ['', Validators.required],
        zipCode: ['', Validators.required],
      description: '',
      email: ['', Validators.required],
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      businessDescription: ['', Validators.required],
      recaptchaReactive: ['', Validators.required]
    });
    // file: ['', requiredFileType('pdf')],
  }

  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }
    toFormData(this.contactForm.value)
    console.log(this.contactForm)

    this.apiService.sendForm(toFormData(this.contactForm.value), 'business').subscribe(res => {
      console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

}

